import ReactGA from "react-ga4";
import { useLocation } from "react-router";
import { useEffect } from "react";
import { gclidPersister } from "./gclidPersister";
import { useCookieConsent } from "../provider/CookieConsent/CookieConsentProvider";

export default function useTracker(options: { withGclid?: boolean } = {}) {
  const { hasConsent } = useCookieConsent();
  const location = useLocation();
  const page = location.pathname + location.search;

  useEffect(() => {
    if (!hasConsent("analytics")) {
      return;
    }

    ReactGA.set({
      page,
      ...options,
    });
    ReactGA.send({ hitType: "pageview", page: page });
  }, [page, hasConsent]);

  const withGclid = !!options.withGclid;
  useEffect(() => {
    if (withGclid) {
      gclidPersister(page);
    }
  }, [withGclid, page]);
}

export const modalview = (modal: string) => {
  pageview("/modal/" + modal);
}

export const pageview = (page: string) => {
  ReactGA.send({ hitType: "pageview", page: page });
}
